/* istanbul ignore file -- context */
import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

import { useFooter } from '../../../../../../hooks';
import { NewsletterTitleIconType } from '../../../TitleIcon';
import { ButtonAction, SubscriptionProcessStatus } from '../../types';
import type { NewsletterDialogContextType } from './types';
import { getContent } from './utils';

export const defaultNewsletterDialogContextValues: NewsletterDialogContextType = {
  content: {
    buttonAction: ButtonAction.Submit,
    buttonText: '',
    emailLabel: '',
    icon: NewsletterTitleIconType.Subscribe,
    invalidEmailLabel: '',
    ppLinkText: '',
    ppText: '',
    ppUrl: '',
    showButton: false,
    showForm: false,
    text: '',
    title: '',
  },
  status: SubscriptionProcessStatus.Initial,
  setStatus: () => {},
};

export const NewsletterDialogContext = createContext<NewsletterDialogContextType>(defaultNewsletterDialogContextValues);

const { Provider } = NewsletterDialogContext;

export const NewsletterDialogContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [status, setStatus] = useState(SubscriptionProcessStatus.Initial);
  const { newsletterSubsciptionConfiguration } = useFooter();
  const content = useMemo(
    () => getContent({ newsletterSubsciptionConfiguration, status }),
    [newsletterSubsciptionConfiguration, status],
  );

  const value: NewsletterDialogContextType = useMemo(
    () => ({
      content,
      status,
      setStatus,
    }),
    [content, status],
  );

  return <Provider value={value}>{children}</Provider>;
};

export const useNewsletterDialogContext = () => useContext(NewsletterDialogContext);
